import { ComponentType } from "@angular/cdk/overlay";
import { Component, InjectionToken, Input } from "@angular/core";

export const SIDENAV_ITEM_PROVIDERS = new InjectionToken<ISidenavItemProvider[]>('Token per provider degli item nella sidenav');

export interface ISidenavItemDescriptor {
    providerName: string;
}

@Component({ template: '' })
export abstract class ISidenavItemProvider {
    @Input() menuItem: any;
    @Input() onClickEvent: () => {};

    // Method to get the provider description and be able to search by identity.
    abstract describe(): ISidenavItemDescriptor;

    // Method to get the component widget to use based on the type
    abstract evaluate(): ComponentType<any>;

    static getToken(): InjectionToken<ISidenavItemProvider[]> {
        return SIDENAV_ITEM_PROVIDERS;
    }
}